import { Component, inject, type OnInit } from '@angular/core';
import { type BehaviorSubject } from 'rxjs';
import { ViewMode } from './enums/view-mode';
import { Config } from './interfaces/config';
import { ChatService } from './services/chat.service';
import { MessagesService } from './services/messages.service';
import { TitleService } from './services/title.service';
import { Title } from './interfaces/title';
@Component({
    selector: 'big-chat-core-panel',
    template: '',
    standalone: false,
})
export class ChatCorePanelComponent implements OnInit {
    public readonly chatService = inject(ChatService);
    public readonly titleService = inject(TitleService);
    public readonly messagesService = inject(MessagesService);

    public config!: BehaviorSubject<Config>;
    public viewModeEnum: typeof ViewMode = ViewMode;
    public title!: BehaviorSubject<Title>;

    public ngOnInit(): void {
        this.config = this.chatService.getConfig();
        this.title = this.titleService.get();
    }

    public toggleMinimize(): void {
        this.chatService.toggleMinimized();
    }

    public close(): void {
        this.chatService.setVisibility(false);
        this.chatService.setMinimized(false);
        this.chatService.setViewMode(ViewMode.chooseChat);
    }

    public setViewMode(value: ViewMode): void {
        this.chatService.setViewMode(value);
    }

    public onChatToggleHandler(viewMode: ViewMode = ViewMode.chooseChat): void {
        if (this.chatService.currentConfig().panel.viewMode !== viewMode && viewMode !== ViewMode.chooseChat) {
            this.chatService.setVisibility(true);
        } else {
            this.chatService.toggleVisibility();
        }

        this.chatService.setViewMode(viewMode);
    }

    public onHandover(handover: boolean): void {
        if (handover) {
            this.chatService.setViewMode(ViewMode.liveChat);
        }
    }
}
